// if (!customElements.get("discount-flag")) {
//   customElements.define(
//     "discount-flag",
//     class DiscountFlag extends HTMLElement {
//       constructor() {
//         super();
//         this.HTMLpercent = this.querySelector(".discount-flag__discount");
//         this.originalPrice = (this.getAttribute("data-original-price")) ? parseInt(this.getAttribute("data-original-price")) * 0.01 : 0;
//         this.price = (this.getAttribute("data-price")) ? parseInt(this.getAttribute("data-price")) * 0.01 : 0;
        
//         this.init();
//       } 

//       init(){

//         const wrapperProduct = this.closest(".card-wrapper") ?? this.closest("product-info");
//         if(!wrapperProduct) return;

//         const cupomCountdown = wrapperProduct.querySelector("cupom-countdown");
//         if(!cupomCountdown) return;
        
//         const promotion = JSON.parse(sessionStorage.getItem("insider:cart:promotionCoupon"));
//         if(promotion && !promotion?.discount_config?.type && promotion.data && promotion.data?.discount?.value_type !== "fixed_amount"){
//           const price = this.price * (1 - (promotion.data.discount.value * -1) / 100);
//           this.updateDiscountFlag(this.originalPrice, price);
//         }
//       }

//       calculateDiscount(comparePrice, price) {
//         return Math.round(((comparePrice - price) / comparePrice) * 100);
//       }

//       updateDiscountFlag(comparePrice, price) {
//         const discount = this.calculateDiscount(comparePrice, price);
//         if (discount > 0 && discount < 100) {
//           this.HTMLpercent.innerHTML = `${discount}`;
//           this.classList.remove("hidden");
//         } else {
//           this.classList.add("hidden");
//         }
//       }
//     }
//   );
// }
